import { ConfirmDialog } from "./confirm-dialog";

type LogoutAlertProps = {
  onLogout: () => void;
  onClose: () => void;
  isOpen: boolean;
};

export const LogoutAlert = ({ isOpen, onClose, onLogout }: LogoutAlertProps) => {
  return (
    <ConfirmDialog
      confirmLabel="Log out"
      description="You will need to sign in again to see your care plan."
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onLogout}
      title="Log out?"
    />
  );
};
